import { Button } from '@/components/ui/button';
import { Upload, Sparkles, Loader2 } from 'lucide-react';

const OCRUpload = ({ ocrButtons, onUpload, loading }) => {
  return (
    <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl p-6 border border-blue-100">
      <div className="flex items-start gap-3 mb-4">
        <div className="p-2 bg-blue-100 rounded-lg">
          <Sparkles className="w-5 h-5 text-blue-600" />
        </div>
        <div className="flex-1">
          <h3 className="font-semibold text-gray-900 mb-1">AI-Powered Quick Fill</h3>
          <p className="text-sm text-gray-600">Upload documents (PDF, JPG, PNG) to auto-extract information using OCR</p>
        </div>
      </div>
      <div className="grid grid-cols-3 gap-3">
        {ocrButtons.map((btn) => (
          <div key={btn.id}>
            <Button
              variant="outline"
              size="sm"
              disabled={loading}
              className="w-full bg-white hover:bg-blue-50 border-blue-200"
              data-testid={`ocr-${btn.id}-btn`}
              onClick={() => document.getElementById(`${btn.id}-upload`)?.click()}
            >
              <Upload className="w-3.5 h-3.5 mr-2" />
              {btn.label}
            </Button>
            <input
              id={`${btn.id}-upload`}
              type="file"
              accept="image/*,application/pdf"
              className="hidden"
              onChange={(e) => onUpload(e, btn.type)}
            />
          </div>
        ))}
      </div>
      {loading && (
        <div className="mt-4 text-sm text-blue-700 flex items-center gap-2 bg-blue-100 px-4 py-2 rounded-lg">
          <Loader2 className="w-4 h-4 animate-spin" />
          Extracting data from document...
        </div>
      )}
    </div>
  );
};

export default OCRUpload;
